<bl-page-card-container
  data-smartpresentation="container-pagina"
  id="ranking-medicos-consultas"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
  >
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY" class="mr-2"></ag-views-toolbar>
      <bl-competencia
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>
      <p-floatlabel variant="on" class="ml-2">
        <p-select
          size="small"
          [options]="anosBasesOptions"
          [(ngModel)]="anoBase"
          (onChange)="filterChanged = true"
        ></p-select>
        <label>Realização</label>
      </p-floatlabel>
      <p-floatlabel variant="on" class="ml-2">
        <p-select
          size="small"
          [options]="faixasEtariasOptions"
          [(ngModel)]="faixaEtaria"
          (onChange)="filterChanged = true"
        ></p-select>
        <label>Faixa Etária</label>
      </p-floatlabel>
      <bl-analises-filtro class="ml-2" [(data)]="filterData" (onChange)="filterChanged = true"></bl-analises-filtro>
      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="ml-2 mr-4 p-button p-button-md"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        (click)="reloadData()"
      ></button>

      @if (pseudonimizarActionVisible) {
        <button
          class="p-button p-button-outlined p-button-icon-only"
          (click)="togglePseudonimizar()"
          [title]="(pseudonimizarAction ? 'Desativar' : 'Ativar') + ' Pseudonimização'"
          >
          <i class="pi" [ngClass]="pseudonimizarAction ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      }
      <button
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="exportExcel()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="!rowData?.length"
        >
        <i class="pi pi-file-excel"></i>
      </button>
      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
        >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
          >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-1">
    <ag-grid-angular
      #agGrid
      data-smartpresentation="ag-grid"
      class="ag-theme-balham w-full"
      [style.height]="gridHeight$ | async"
      [rowData]="rowData"
      [gridOptions]="gridOptions"
      [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
      >
    </ag-grid-angular>
  </div>
</bl-page-card-container>

<p-dialog
  [(visible)]="dialogDisplay"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  (onMaximize)="onDialogMaximize($event)"
  (onHide)="onDialogHide($event)"
  [style]="{ width: '90vw', height: '90vh' }"
  >
  <ng-template pTemplate="header">
    <div class="flex justify-content-between w-full">
      <h5>Listagem das Guias</h5>
      <div class="flex align-items-center gap-2 mr-2">
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-left"
          class="p-button-secondary p-button-text p-button-rounded p-button-icon-only"
          (click)="showDialogForPrev()"
          [disabled]="selectedRowIndex <= 0"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-right"
          class="p-button-secondary p-button-text p-button-rounded p-button-icon-only"
          (click)="showDialogForNext()"
          [disabled]="selectedRowIndex > medicoCpfList.length - 2"
        ></button>
      </div>
    </div>
  </ng-template>

  <div class="flex justify-content-between mb-2">
    <div>
      <div>
        <strong>Competência:</strong> {{ competenciaRange[0] | competencia }} até
        {{ competenciaRange[1] | competencia }}
      </div>
      <div><strong>Médico:</strong> {{ dialogSubtitle }}</div>
    </div>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGridDialog" [gridKey]="GRID_DIALOG_KEY" class="mr-2"></ag-views-toolbar>
      @if (pseudonimizarActionVisible) {
        <button
          class="p-button p-button-outlined p-button-icon-only"
          (click)="togglePseudonimizar()"
          [title]="(pseudonimizarAction ? 'Desativar' : 'Ativar') + ' Pseudonimização'"
          >
          <i class="pi" [ngClass]="pseudonimizarAction ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      }

      <button
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="exportExcelDialog()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="!dialogData?.length"
        >
        <i class="pi pi-file-excel"></i>
      </button>
    </div>
  </div>

  <div class="flex flex-1">
    <ag-grid-angular
      #agGridDialog
      class="ag-theme-balham w-full"
      [style.height]="'calc(90vh - ' + dialogHeightPadding + 'px)'"
      [rowData]="dialogData"
      [gridOptions]="gridDialogOptions"
      >
    </ag-grid-angular>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="detalheGuiaDisplay"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  header="Detalhes da guia/lançamento"
  >
  <bl-detalhes-guia
    [operadora]="operadora"
    [cdGuiaMonitor]="detalheGuiaCodigo"
    (onChange)="showDetalheGuiaFor($event)"
  ></bl-detalhes-guia>
</p-dialog>
